import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./axiosAuthProvider";
import LoadingIndicator from "./components/molecules/LoadingIndicator";

const root = createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <App />
    <LoadingIndicator />
  </BrowserRouter>
  // </React.StrictMode>
);
serviceWorker.unregister();
